export class LanguageSwitch {
  private linkElements;
  private link;
  private languageMenuA;

  constructor() {
    this.linkElements = document.getElementsByTagName('link');
    this.languageMenuA = document.querySelectorAll('.header-lang a');
    this.link = [];
    this.listeners();
  }

  listeners() {
    let en = 'en';
    for (let item of this.linkElements) {
      if (item.hreflang) {
        item.hreflang = item.hreflang.toLowerCase();
        if (item.hreflang === 'x-default') {
          this.link[en] = item.href;
        }
        this.link[item.hreflang] = item.href;
      }
    }
    for (let item of this.languageMenuA) {
      if (this.link[item.hreflang]) {
        item.setAttribute('href', this.link[item.hreflang]);
      }
    }
  }
}
